// extracted by mini-css-extract-plugin
export default {"list":"list__6pPoD","item":"item__O4Vws","delete":"delete__vZRqr"};